import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { API_URL_PREFIX, BEARER_PREFIX } from './api-auth-conf';

@Injectable()
export class ApiAuthInterceptor implements HttpInterceptor {
  constructor(private auth: AngularFireAuth) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(API_URL_PREFIX)) {
      return next.handle(req);
    }
    return from(this.readToken()).pipe(
      switchMap((token) => next.handle(
        token ? req.clone({ setHeaders: { Authorization: `${BEARER_PREFIX}${token}` } }) : req
      ))
    );
  }

  private async readToken(): Promise<string | null> {
    const user = await this.auth.currentUser;
    return user ? user.getIdToken() : null;
  }
}
